// extracted by mini-css-extract-plugin
export var numpadContainer = "_px-1";
export var phoneButton = "_px-0";